module.exports = __webpack_public_path__ + "img/project-prolog-3.487ec496.png";